<template>

  <DxDataGrid :allowColumnReordering="true" :data-source="dsPreturiFurnizori" :allowColumnResizing="true"
              :columnAutoWidth="false" :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
              :syncLookupFilterValues="false" @exporting="onExporting" :filter-sync-enabled="true">

    <DxFilterRow :visible="true"/>
    <DxPaging :page-size="15" :page-index="1"/>
    <DxGrouping :context-menu-enabled="true">
      <DxTexts group-continued-message="Continuat de pe pagina anterioara"
               group-continues-message="Continuat pe pagina urmatoare"/>

    </DxGrouping>
    <DxGroupPanel :visible="true" emptyPanelText="Trage aici o coloana pentru a grupa datele"/>
    <DxLoadPanel :enabled="true"/>
    <DxSorting mode="multiple"/>
    <DxStateStoring :enabled="true" :filterValue="false" storage-key="PreturiFurnizori"/>
    <DxColumnChooser :enabled="true" title="Selector coloane"></DxColumnChooser>

    <DxSelection mode="multiple"/>
    <DxExport :enabled="true" :formats="['pdf', 'xlsx']" :allow-export-selected-data="true"/>


    <DxSearchPanel :visible="true" :width="240" placeholder="Cauta ..."></DxSearchPanel>

    <DxColumn caption="Furnizor" data-field="FurnizorCUI">
      <DxLookup :data-source="dsParteneri" display-expr="Nume" value-expr="CUI">
      </DxLookup>
    </DxColumn>

    <DxColumn data-field="PretIntrareValuta"/>

    <DxColumn data-field="Moneda"/>

    <DxColumn data-field="StocFurnizor"/>

    <DxColumn data-field="ProdusCod"/>

    <DxColumn data-field="Categorie"/>

    <DxColumn data-field="ProdusNume"/>

    <DxColumn data-field="Garantie"/>


    <DxColumn :visible="false" data-field="PretIntrareLei"/>
    <DxColumn :visible="false" data-field="CursFacturareLei"/>
    <DxColumn :visible="false" data-field="Discount"/>
    <DxColumn :visible="false" data-field="PretNediscountat"/>
    <DxColumn :visible="false" data-field="StocEva"/>
    <DxColumn :visible="false" data-field="Explicatie"/>
    <DxColumn :visible="false" data-field="ProdusCodIntern"/>
    <DxColumn :visible="false" data-field="TimbrulVerdeLei"/>


  </DxDataGrid>

</template>
<script lang="ts">

import {
  DxColumn,
  DxColumnChooser,
  DxDataGrid,
  DxEditing,
  DxExport,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxHeaderFilter,
  DxLoadPanel,
  DxLookup,
  DxPager,
  DxPaging,
  DxRemoteOperations,
  DxScrolling,
  DxSearchPanel,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxTexts
} from 'devextreme-vue/data-grid';

import ODataStore from 'devextreme/data/odata/store';

import PreturiFurnizoriDataService from '@/services/Comercial/PreturiFurnizori'
import ResponseData from '@/types/responseData';
import AppSetting from '@/settings/appSettings'
import 'devextreme/data/array_store';

import {jsPDF} from 'jspdf';
import {exportDataGrid as exportDataGridPdf} from 'devextreme/pdf_exporter';
import {exportDataGrid as exportDataGridExcel} from 'devextreme/excel_exporter';
import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver';
import {defineComponent} from 'vue'

export default defineComponent({
  components: {
    DxDataGrid,
    DxColumn,
    DxSorting,
    DxSelection,
    DxFilterRow,
    DxSearchPanel,
    DxStateStoring,
    DxPager,
    DxColumnChooser,
    DxLookup,
    DxEditing,
    DxScrolling,
    DxLoadPanel,
    DxRemoteOperations,
    DxHeaderFilter,
    DxPaging,
    DxGrouping,
    DxGroupPanel,
    DxTexts,
    DxExport
  },
  data() {
    return {
      dsPreturiFurnizori: {} as ODataStore,
      dsParteneri: {} as any,


    };
  },
  mounted() {

    this.getPartners();

    this.createODataContext();

  },
  methods: {
    createODataContext() {
      this.dsPreturiFurnizori = new ODataStore({
        url: AppSetting.API_Url_ComercialOdata + 'COM_PreturiFurnizori',
        key: 'UniqueID',
        version: 4,
        beforeSend: (e) => {

          e.headers = {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")

          };
        }
      });

    },

    getPartners() {
      PreturiFurnizoriDataService.getPartners()
          .then((response: ResponseData) => {
            this.dsParteneri = response.data;

          })
          .catch((e: Error) => {
            console.log(e)
          });
    },

    onExporting(e: any) {


      if (e.format === 'pdf') {
        const doc = new jsPDF();
        exportDataGridPdf({
          jsPDFDocument: doc,
          component: e.component,
          indent: 5,
        }).then(() => {
          doc.save('PreturiFurnizori.pdf');
        });
      } else if (e.format === 'xlsx') {

        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('preturi');

        exportDataGridExcel({
          component: e.component,
          worksheet,
          autoFilterEnabled: true,
        }).then(() => {
          workbook.xlsx.writeBuffer().then((buffer: any) => {
            saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'PreturiFurnizori.xlsx');
          });
        });
        e.cancel = true;

      }

    },


  }


});
</script>